import React from "react";

const SingleStringSetting = ({
  label,
  onChange,
  value,
  placeholder,
  description,
  disabled = false
}) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <input
        type="text"
        className="form-control fantastic-form-control"
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        value={value}
        disabled={disabled}
      />
      {description && (
        <small className="form-text text-muted">{description}</small>
      )}
    </div>
  );
};

export default SingleStringSetting;
